import { clamp } from '@/lib/utils'

export const clampFactor = (
  value: number,
  { min, max }: { min: number; max: number } = { min: 0, max: 100 }
) => clamp(value, min, max)
